import { newDate } from "utils/dateUtils";
import { TextConstants } from "./TextConstants";

export const TEXT_CONSTANTS_COD_PORTAL = {
  EXCEL: "excel",
  EXCEL_ORDERS: "excelOrders",
  EXCEL_SUMMARY: "excelSummary",
};

export const exportUrlsConst = {
  DRIVER: "/fulfilment/v2/export/express/cod/assignee-summary",
  ORDER: "/fulfilment/v2/export/express/cod/order-summary",
  SUMMARY: "/fulfilment/v2/export/express/cod/summary",
};

export const EXPORT_TYPES = {
  DRIVER: "DRIVER",
  ORDER: "ORDER",
  SUMMARY: "SUMMARY",
};

export const getExportButtonConfig = () => {
  return [
    {
      name: TEXT_CONSTANTS_COD_PORTAL.EXCEL,
      displayName: TextConstants.EXPORT_DRIVER_DATA,
      disabled: false,
    },
    {
      name: TEXT_CONSTANTS_COD_PORTAL.EXCEL_ORDERS,
      displayName: TextConstants.EXPORT_ORDER_DATA,
      disabled: false,
    },
    {
      name: TEXT_CONSTANTS_COD_PORTAL.EXCEL_SUMMARY,
      displayName: TextConstants.EXPORT_COD_SUMMARY,
      disabled: false,
    },
  ];
};

export const RESPONSE_CONSTANTS = {
  ERROR_CODES: {
    SESSION_TIMEOUT: "UM100",
    UNAUTHORISED: "UM101",
    CONCURRENT_CONSIGNMENT: "CWO15",
  },
};

export const SEARCH_TYPES = [
  {
    name: "Consignment ID",
    value: "consignmentCode",
  },
];

export const SEARCH_TYPES_DRIVER= [
    {
      name: "Driver Name",
      value: "driverName",
    },
  ]

export const defaultFiltersObj = {
  pageNumber: 0,
  deliveryStatus: {
    key: "deliveryStatus",
    value: [],
  },
  dateRange: {
    key: "dateRange",
    value: {
      startDate: newDate(),
      endDate: newDate(),
    },
  },
};

export const defaultFiltersObjDriver = {
    pageNumber: 0,
    driverName: {
      key: "driverNames",
      value: [],
    },
    vendorName: {
      key: "vendorNames",
      value: [],
    },
    dateRange: {
      key: "dateRange",
      value: {
        startDate: newDate(),
        endDate: newDate(),
      },
    },
  }

export const loadMore = {
  name: "loadMore",
  disabled: false,
  pageSize: 100,
};

export const headerButtons= [
    {
      name: "colsettings",
      displayName: "Column Settings",
      disabled: false,
      childElements: getExportButtonConfig(),
    },
  ]



const CODPortalConstants = {
  COD_RECON_CONSTANTS: {
    DRIVERS_DATA: {
      TABLE_WRAPPER_DATA: {
        title: "Drivers",
        HeaderData: [
          {
            field: "id",
            headerName: "Id",
            hide: true,
          },
          {
            field: "driverName",
            headerName: "Driver Name",
            width: 100,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "driverName",
              fieldName: "driverName",
              fieldFullName: "driverName",
              multiple: true,
              key: `autoComplete-driverName`,
              label: "Driver Name",
              items: [],
            },
          },
          {
            field: "totalOrders",
            headerName: "Total COD Orders",
            width: 130,
          },
          {
            field: "codCollected",
            headerName: "Total COD Collected (By Driver)",
            width: 186,
          },
          {
            field: "codReceived",
            headerName: "COD amount recieved (By Dispatcher)",
            width: 180,
          },
          {
            field: "codPending",
            headerName: "Total COD amount Due",
            width: 180,
          },
          {
            field: "vendor",
            headerName: "Vendor Name",
            width: 180,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "vendorName",
              fieldName: "vendorName",
              fieldFullName: "vendorName",
              multiple: true,
              key: `autoComplete-vendorName`,
              label: "Vendor",
              items: [],
            },
          },
          {
            field: "actions",
            headerName: "Actions",
            width: 100,
            hide: false,
          },
        ],
        headerButtons,
        loadMore: {
          name: "loadMore",
          disabled: false,
          pageSize: 50,
        },
        defaultFiltersObj: defaultFiltersObjDriver,
        SEARCH_TYPES: SEARCH_TYPES_DRIVER,
      },
    },

    ORDERS_DATA: {
      TABLE_WRAPPER_DATA: {
        title: "Orders",
        HeaderData: [
          {
            field: "id",
            headerName: "Id",
            hide: true,
          },
          {
            field: "orderNo",
            headerName: "Order Number",
            width: 130,
          },
          {
            field: "deliveryStatus",
            headerName: "Delivery Status",
            width: 170,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "deliveryStatus",
              fieldName: "deliveryStatus",
              fieldFullName: "deliveryStatus",
              multiple: true,
              key: `autoComplete-deliveryStatus`,
              label: "Delivery Status",
              items: [],
            },
          },
          {
            field: "orderDate",
            headerName: "Order Date",
            width: 130,
          },
          {
            field: "activity",
            headerName: TextConstants.ACTIVITY_TYPE,
            width: 100,
          },
          {
            field: "slot",
            headerName: "Slot",
            width: 140,
          },
          {
            field: "codCollected",
            headerName: "Total COD Collected (By Driver)",
            width: 130,
            hide: false,
          },
          {
            field: "codReceived",
            headerName: "COD Amount Received (By Dispatcher)",
            width: 130,
            hide: false,
          },
          {
            field: "codAmountDue",
            headerName: "Total COD Amount Due",
            width: 180,
            hide: false,
          },
          {
            field: "remarks",
            headerName: "Remarks",
            width: 170,
            hide: false,
          },
          {
            field: "collectionStatus",
            headerName: "Collection Status",
            width: 110,
            hide: false,
          },
        ],
        loadMore,
        defaultFiltersObj,
        SEARCH_TYPES,
      },
    },

    MAX_FILE_SIZE: "File Size cannot exceed 5 MB",
    MAX_FILE_SIZE_ALLOWED: 5242880,
    UPLOAD_MESSAGES: {
      ERROR: "error",
      SUCCESS: "success",
      MAX_SIZE: "maxSize",
    },
    VALIDATIONS: {
      NAME: {
        REQUIRED: {
          msg: "Receipt name is required",
        },
        VALIDITY: {
          msg: "Special Case Character not allowed",
          value: /^[a-z0-9]+$/i,
        },
      },
    },
    RESPONSE_CONSTANTS: {
      ERROR_CODES: {
        SESSION_TIMEOUT: "UM100",
        UNAUTHORISED: "UM101",
        CONCURRENT_CONSIGNMENT: "CWO15",
      },
    },
  },
};
export default CODPortalConstants;
